import ApplicationAdapter from './application';

export default class BadgeAdapter extends ApplicationAdapter {
  pathForType() {
    return 'badges';
  }
}
